<template>
	<div class="nav-link-wrapper watch-list">
		<router-link v-if="selectedAccount" class="nav-link" :to="{ name: 'WatchList', params: { user_uid: selectedAccount } }">
			<svgicon name="watch" :fill="false"></svgicon>
			<span>{{ $t('base.general.patients') }}</span>
			<div class="dropdown-toggle" @click.stop.prevent="onDropdownToggleClick($event)">&#9662;</div>
		</router-link>
		<div class="dropdown-content" @transitionend="updateShadow" ref="watches">
			<spinner v-if="!patients.data.length && patients.loading"/>
			<router-link v-else :to="{ name: 'WatchDashboard', params: { user_uid: selectedAccount, watch_id: watch.id } }" v-for="watch in patients.data" :key="watch.id" :class="{ 'router-link-active' : matchWatchUser(selectedAccount, watch.id) }">{{ watch.profile_name }}</router-link>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'updateShadow',
		'onDropdownToggleClick'
	],
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		patients () {
			return this.$store.getters.getAccountWatches(this.selectedAccount)
		}
	},
	methods: {
		matchWatchUser (user_uid, watch_id) {
			return this.$route.path.match(new RegExp(`\/users\/${user_uid}\/watches\/${watch_id}`))
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationPatients.vue